export default __webpack_public_path__ + "static/media/mobile-background.0884977f.jpg";